/**
 * useSubmitFulfillmentClaim
 *
 * Calls POST /rewards/fulfillment-claim. Submits a winner's shipping +
 * contact info for a physical-ship reward (MERCH or manual GIFT_CARD).
 *
 * One submission per (user, prizePoolId) — server-side unique index
 * throws 409 on duplicate. The PrizeWonModal that hosts the form
 * surfaces the 409 as "already submitted for this prize" so the user
 * understands without having to refresh.
 */
import { useMutation } from "@tanstack/react-query";
import { RewardsApi, RewardFulfillmentClaimBody, RewardFulfillmentClaimResponse } from "@devour/client";
import { useSelector } from "react-redux";
import getConfig from "@/utils/getConfig";
import { IStore } from "@/redux/defaultStore";

export function useSubmitFulfillmentClaim() {
    const fullToken = useSelector((store: IStore) => store.authStore.fullToken);

    return useMutation({
        mutationFn: async (body: RewardFulfillmentClaimBody): Promise<RewardFulfillmentClaimResponse> => {
            const api = new RewardsApi(getConfig(fullToken));
            return api.createRewardsFulfillmentClaim({ rewardFulfillmentClaimBody: body });
        },
    });
}
